import { assertNever } from '@kofno/piper';
import ReactionComponent, { RCProps } from '../../ReactionComponent';
import ModalStore from './Store';
import clickOutsideStore from '../../ClickOutsideStore';
import { State } from './Store/Types';

interface Props extends RCProps<ModalStore> {}

class ModalReactions extends ReactionComponent<ModalStore, State, Props> {
  componentWillUnmount() {
    clickOutsideStore.enable();
  }

  tester = () => this.props.store.state;

  effect = (state: State) => {
    switch (state.kind) {
      case 'closed':
        clickOutsideStore.enable();
        break;
      case 'open':
        clickOutsideStore.disable();
        break;
      default:
        assertNever(state);
    }
  };
}

export default ModalReactions;
